import { render } from "./UserViewPartial.vue?vue&type=template&id=838736d6"
import script from "./UserViewPartial.vue?vue&type=script&lang=js"
export * from "./UserViewPartial.vue?vue&type=script&lang=js"

import "./UserViewPartial.vue?vue&type=style&index=0&id=838736d6&lang=css"
script.render = render

export default script